<!--
* 组件名 : 书籍内容
* 开发者 : JY
*
* 参数:
*   pageDataItem     { Array } -  书籍数据
*   bookInfo         { Object } -  书籍数据
* 事件: null
*
*
-->
<template>
  <section class="book-contents">
    <div class="book-container">
      <div class="book-poster">
        <a :href="bookInfo.link" class="book-img" target="_blank">
          <img :src="bookInfo.poster" :alt="bookInfo.title" />
        </a>
      </div>
      <book-selector :bookData="pageDataItem" />
    </div>
  </section>
</template>

<script>
import bookSelector from "./components/book-selector/index.vue";
export default {
  name: "book-contents",
  props: {
    pageDataItem: {
      type: Array,
      required: true,
    },
    bookInfo: {
      type: Object,
      required: true,
    },
  },
  components: {
    bookSelector,
  },
};
</script>

<style lang="scss">
.book-contents {
  width: 100%;
  padding-top: 54px;

  .book-container {
    width: 950px;
    margin: auto;
    padding-top: 34px;
  }

  .book-poster {
    width: 180px;
    margin: auto;

    .book-img {
      display: block;
      width: 100%;
      padding-top: 145.56%;
      position: relative;
      background-color: $color-placeholder;

      img {
        position: absolute;
        top: 0;
        left: 0;
        max-width: 100%;
      }
    }
  }
}
</style>
